export default {
    getPermission(permission_access, permission_code_name) {
        if (!permission_access) {
            return 1;
        }
        return permission_access[permission_code_name];
    },
}
